import styled, { css } from 'styled-components';
import { calcOpacity } from 'utils/calcOpacity';
import {
  AVATAR_DESKTOP_INITIAL_SIZE,
  AVATAR_DESKTOP_TOTAL_WIDTH,
  CLOSE_BUTTON_TOTAL_HEIGHT,
  CLOSE_BUTTON_TOTAL_WIDTH,
} from './constants';

export const ContentWrapper = styled.div<{ isSmallProfile: boolean }>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    position: relative;
    padding: ${theme.spacing.km6} ${theme.spacing.km8} ${theme.spacing.km3};
    margin-top: ${CLOSE_BUTTON_TOTAL_HEIGHT}px;
  `}

  ${({ isSmallProfile }) =>
    isSmallProfile &&
    css`
      flex-direction: column;
      align-items: center;
    `}
`;

export const InfoWrapper = styled.div<{ scrolledValue: number; showCloseButton: boolean; isSmallProfile: boolean }>`
  ${({ scrolledValue, showCloseButton, isSmallProfile }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${!isSmallProfile &&
    css`
      ${scrolledValue <= AVATAR_DESKTOP_INITIAL_SIZE &&
      !showCloseButton &&
      css`
        width: calc(100% - ${AVATAR_DESKTOP_TOTAL_WIDTH - scrolledValue}px);
      `}

      ${showCloseButton &&
      scrolledValue <= AVATAR_DESKTOP_INITIAL_SIZE &&
      css`
        width: calc(
          100% - ${AVATAR_DESKTOP_TOTAL_WIDTH - scrolledValue}px -
            ${scrolledValue < CLOSE_BUTTON_TOTAL_WIDTH ? scrolledValue : CLOSE_BUTTON_TOTAL_WIDTH}px
        );
      `}
    `}
  `}
`;

export const MenuWrapper = styled.div<{ scrolledValue: number; isSmallProfile?: boolean }>`
  ${({ theme, scrolledValue, isSmallProfile }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    z-index: 19;
    transition: opacity 0s;
    margin: ${theme.spacing.km3} 0 0;

    ${!isSmallProfile &&
    css`
      opacity: ${calcOpacity(110, scrolledValue, 40)};
    `}

    ${isSmallProfile &&
    css`
      opacity: ${calcOpacity(165, scrolledValue, 120)};
      justify-content: center;
    `}
  `}
`;
